var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStationLogoMaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7297_440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.91663 1.83337C5.29163 1.83337 2.66663 2.15794 2.66663 4.42987V10.5965C2.66663 11.8493 3.69694 12.8685 4.9635 12.8685L3.97913 13.8421V14.1667H5.44256L6.75506 12.8685H9.22913L10.5416 14.1667H11.8541V13.8421L10.8698 12.8685C12.1363 12.8685 13.1666 11.8493 13.1666 10.5965V4.42987C13.1666 2.15794 10.8173 1.83337 7.91663 1.83337ZM4.9635 11.5702C4.41881 11.5702 3.97913 11.1353 3.97913 10.5965C3.97913 10.0578 4.41881 9.62285 4.9635 9.62285C5.50819 9.62285 5.94788 10.0578 5.94788 10.5965C5.94788 11.1353 5.50819 11.5702 4.9635 11.5702ZM7.26038 7.02636H3.97913V4.42987H7.26038V7.02636ZM8.57288 7.02636V4.42987H11.8541V7.02636H8.57288ZM10.8698 11.5702C10.3251 11.5702 9.88538 11.1353 9.88538 10.5965C9.88538 10.0578 10.3251 9.62285 10.8698 9.62285C11.4144 9.62285 11.8541 10.0578 11.8541 10.5965C11.8541 11.1353 11.4144 11.5702 10.8698 11.5702Z",
    fill: "#DBBE78"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7297_440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStationLogoMaps);
export default __webpack_public_path__ + "static/media/station-logo-maps.a98731c777542042b7f353ef538dbd26.svg";
export { ForwardRef as ReactComponent };